import React, { useEffect, useState } from "react";
import Menu1 from "../Menu";
import Header from "../Header";
import Footer from "../Footer";
import { Modal, Switch } from "antd";
import { Select } from "antd";
import { Table } from "antd";
import { DatePicker, Space } from "antd";
import { useNavigate } from "react-router";
import { GetAllMainCategoryList, updateBudget } from "./Actions/BudgetService";
import { useDispatch, useSelector } from "react-redux";

const { Option } = Select;
const { RangePicker } = DatePicker;

const BudgetCategoryMaster = () => {
  const title = "Budget Category Master";
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    budget_type: "",
    main_category_id: "",
    active: 0,
  });

  const [IsBudgetCategoryOpen, setIsBudgetCategoryOpen] = useState(false);
  const [IsView, setIsView] = useState(false);
  const [IsEdit, setIsEdit] = useState(false);
  const [TableData, setTableData] = useState([]);
  const [budgetId, setBudgetId] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const mainCategoryList = useSelector(
    (state) => state?.BudgetList?.AllData?.MainCategoryList
  );
  const updateFormData = (id, value,active) => {
    if(active=="Inactive"){
        setFormData({...formData,main_category_id: id, budget_type: value ,active:0})
    }
    else if(active=="Active"){
        setFormData({...formData,main_category_id: id, budget_type: value ,active:1})
        
    }
  };
  console.log(mainCategoryList, "mainCategoryList");
  const dispatch = useDispatch();
  const _doNavToCreateBudgetCategory = () => {
    setIsBudgetCategoryOpen(true);
    setIsView(false);
    setIsEdit(false);
  };
  const _doNavToEditBudgetCateory = (record) => {
    const { id ,active} = record;
    console.log(record, "record");
    if (budgetId == "preventive_maintenance") {
      updateFormData(id, "1",active);
    }
    else if (budgetId == "corrective_maintenance") {
        updateFormData(id, "2",active);
    
      } else if (budgetId == "maintenance_annual_expenses") {
        updateFormData(id, "3",active);
      } else if (budgetId == "maintenance_annual_investment") {
        updateFormData(id, "4",active);
      } else if (budgetId == "tpv_audit") {
        updateFormData(id, "5",active);
      } else if (budgetId == "house_keeping") {
        updateFormData(id, "6",active);
      } else if (budgetId == "security_services") {
        updateFormData(id, "7",active);
      } else if (budgetId == "energy_other_bills") {
        updateFormData(id, "8",active);
      }

    setIsBudgetCategoryOpen(true);
    setIsEdit(true);
    setIsView(false);
  };
  const _doNavToViewBudgetCategory = (record) => {
    console.log(record, "record");
const {id,active}=record
    // setFormData({ ...formData, main_category_id: record.id });
    if (budgetId == "preventive_maintenance") {
        // setFormData({...formData,main_category_id:record.id,budget_type:"1"})
        updateFormData(id, "1",active);
      }
      else if (budgetId == "corrective_maintenance") {
        updateFormData(id, "2",active);
    
      } else if (budgetId == "maintenance_annual_expenses") {
        updateFormData(id, "3",active);
      } else if (budgetId == "maintenance_annual_investment") {
        updateFormData(id, "4",active);
      } else if (budgetId == "tpv_audit") {
        updateFormData(id, "5",active);
      } else if (budgetId == "house_keeping") {
        updateFormData(id, "6",active);
      } else if (budgetId == "security_services") {
        updateFormData(id, "7",active);
      } else if (budgetId == "energy_other_bills") {
        updateFormData(id, "8",active);
      }
   
    setIsBudgetCategoryOpen(true);
    setIsEdit(false);
    setIsView(true);
  };
  const HandleSubmit = () => {
    // dispatch(SaveBudgetCategoryMaster(formData))
    console.log(formData, "formDataformData");
    setIsSubmit(true);
    if (formData.budget_type == "") {
      return;
    } else if (formData.main_catupdateBudgetegory_id == "") {
      return;
    }
    formData.budget_type = Number(formData.budget_type);
    dispatch(updateBudget(formData));
    _doCloseModal();
    navigate("/BudgetCategoryMaster");
    setIsSubmit(false);
  };
  console.log(isSubmit, "isSubmit");
  const handleSearch = () => {
    if (budgetId == "preventive_maintenance") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.preventive_maintenance == 1
      );
      setTableData(fetchData);
      console.log(fetchData, "fetchData");
    } else if (budgetId == "corrective_maintenance") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.corrective_maintenance == 1
      );
      setTableData(fetchData);
      console.log(fetchData, "fetchData");
    } else if (budgetId == "maintenance_annual_expenses") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.maintenance_annual_expenses == 1
      );
      setTableData(fetchData);
    } else if (budgetId == "maintenance_annual_investment") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.maintenance_annual_investment == 1
      );
      setTableData(fetchData);
    } else if (budgetId == "tpv_audit") {
      const fetchData = mainCategoryList?.filter((e) => e.tpv_audit == 1);
      setTableData(fetchData);
      console.log(fetchData, "fetchData");
    } else if (budgetId == "house_keeping") {
      const fetchData = mainCategoryList?.filter((e) => e.house_keeping == 1);
      setTableData(fetchData);
    } else if (budgetId == "security_services") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.security_services == 1
      );
      setTableData(fetchData);
    } else if (budgetId == "energy_other_bills") {
      const fetchData = mainCategoryList?.filter(
        (e) => e.energy_other_bills == 1
      );
      setTableData(fetchData);
    }
  };
  const _doCloseModal = () => {
    setIsBudgetCategoryOpen(false);
    setFormData({});
  };
  const _doSelectVender = () => {};
  const TableColumns = [
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <div className="table-icons">
            <i
              onClick={() => {
                _doNavToViewBudgetCategory(record);
              }}
              className="fa fa-eye orange"
            ></i>
            <i
              onClick={() => {
                _doNavToEditBudgetCateory(record);
              }}
              className="fa fa-pencil blue"
            ></i>
          </div>
        </Space>
      ),
    },

    {
      title: "Main Category",
      dataIndex: "main_category_name",
      key: "main_category_name",
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
    },
  ];
  useEffect(() => {
    dispatch(GetAllMainCategoryList());
  }, []);
  console.log(formData,"TestingFormData")
  return (
    <div className="wrapper">
      <Header title={title} />
      <Menu1 />
      <div className="content-wrapper">
        <div className="m-btn-block">
          <div className="m-btn-block__container">
            <div className="m-btn-block__icon">
              <i className="fa fa-plus-circle" aria-hidden="true"></i>
            </div>
            <div className="m-btn-block__btns">
              <button
                type="submit"
                onClick={_doNavToCreateBudgetCategory}
                className="btn btn-secondary deca-btn-yellow"
              >
                Create Master
              </button>
            </div>
          </div>
        </div>

        <section className="content top-space">
          <div className="m-panel mt-10">
            <div className="m-pannel__body p-10">
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="exampleInput">Budget Category*</label>
                    <Select
                      className="form-control"
                      showSearch
                      onChange={(value) => {
                        setBudgetId(value);
                      }}
                      placeholder="-- Please Select --"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value="preventive_maintenance">
                        Preventive Maintenance
                      </Option>
                      <Option value="corrective_maintenance">
                        Corrective Maintenance{" "}
                      </Option>
                      <Option value="maintenance_annual_expenses">
                        Maintenance Annual Expenses{" "}
                      </Option>
                      <Option value="maintenance_annual_investment">
                        Maintenance Annual Investment{" "}
                      </Option>
                      <Option value="tpv_audit">Tpv Audit </Option>
                      <Option value="house_keeping">House Keeping </Option>
                      <Option value="security_services">
                        Security Services{" "}
                      </Option>
                      <Option value="energy_other_bills">
                        Energy Other bills{" "}
                      </Option>
                    </Select>
                  </div>
                </div>
                <div className="col-md-1 btn-no-lbl">
                  <button
                    type="submit"
                    className="btn btn-secondary btn-icon deca-btn-yellow"
                    onClick={handleSearch}
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="m-panel">
            <div className="m-panel__body p10">
              <div className="m-table__main">
                <div className="m-table__responsive medium-width">
                  <Table
                    scroll={{ y: 300 }}
                    pagination={false}
                    columns={TableColumns}
                    dataSource={TableData}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
      {IsBudgetCategoryOpen === true ? (
        <div className="m-modal">
          <div className="m-modal__container">
            <div className="m-modal__header">
              {IsEdit === false && IsView === false ? (
                <h5 className="m-modal__title">
                  Create Budget Category Master
                </h5>
              ) : null}
              {IsEdit === true && IsView === false ? (
                <h5 className="m-modal__title">Edit Budget Category Master</h5>
              ) : null}
              {IsEdit === false && IsView === true ? (
                <h5 className="m-modal__title">View Budget Category Master</h5>
              ) : null}

              <span className="m-modal__close" onClick={_doCloseModal}>
                <i className="fa fa-close"></i>
              </span>
            </div>
            <div className="m-modal__body">
              <div className="row">
                {/* <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select Period*</label>
                                            <Select className="form-control"
                                                showSearch
                                                disabled={IsView}
                                                onChange ={(value)=>setFormData({...formData,BudgetPeriod:value})}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value='1'>2021</Option>
                                                <Option value='2'>2022</Option>
                                                <Option value='3'>2023</Option>
                                            </Select>
                                        </div>
                                    </div> */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="exampleInput">Budget Category*</label>
                    <Select
                      className="form-control"
                      showSearch
                      disabled={IsView}
                      value={formData.budget_type}
                      onChange={(value) =>
                        setFormData({ ...formData, budget_type: value })
                      }
                      placeholder="-- Please Select --"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      <Option value="1">Preventive Maintenance</Option>
                      <Option value="2">Corrective Maintenance </Option>
                      <Option value="3">Maintenance Annual Expenses </Option>
                      <Option value="4">Maintenance Annual Investment </Option>
                      <Option value="5">TPV Audit </Option>
                      <Option value="6">House Keeping </Option>
                      <Option value="7">Security Services </Option>
                      <Option value="8">Energy Other bills </Option>
                    </Select>
                    {formData.budget_type == "" && isSubmit == true && (
                      <span>Please select Budget Category</span>
                    )}
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="exampleInput">Asset Main Category*</label>
                    <Select
                      className="form-control"
                      showSearch
                      disabled={IsView}
                      value={formData.main_category_id}
                      onChange={(value) =>
                        setFormData({ ...formData, main_category_id: value })
                      }
                      placeholder="-- Please Select --"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {mainCategoryList?.map((e) => (
                        <Option value={e.id} key={e.id}>
                          {e.main_category_name}
                        </Option>
                      ))}
                    </Select>
                    {formData.main_category_id == "" && isSubmit == true && (
                      <span>Please select Asset Main Category</span>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-12">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Period*</label>
                                            <RangePicker onChange ={(value)=>console.log(value,"valuevalues")} direction="horizontal" disabled={IsView} size={12}
                                            className="form-control" />
                                        </div>
                                    </div> */}
                <div className="col-md-12">
                  <div className="form-group">
                    <label htmlFor="exampleInput" required>
                      Status*
                    </label>
                    <div>
                      <Switch
                        disabled={IsView}
                        checkedChildren="Active"
                        unCheckedChildren="InActive"
                        // checked={formData.active == 0 ? false: true}
                        onChange={(status) =>
                          setFormData({
                            ...formData,
                            active: status == true ? 1 : 0,
                          })
                        }
                        defaultChecked={formData.active==0?false:true}
                      ></Switch>
                    </div>
                  </div>
                </div>
                {IsView === true ? null : (
                  <div className="col-md-12 text-center">
                    <div className="m-page__button top-space text-center">
                      <button
                        type="button"
                        onClick={_doCloseModal}
                        className="btn muted-button deca-btn-yellow color-red"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={HandleSubmit}
                        className="btn btn-secondary deca-btn-yellow"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        false
      )}
      {IsBudgetCategoryOpen === true ? (
        <div className="overlay" onClick={_doCloseModal}></div>
      ) : (
        false
      )}
    </div>
  );
};

export default BudgetCategoryMaster;
